
import React from "react";
import { Eye, EyeOff } from "lucide-react";

interface PasswordToggleProps {
  showPassword: boolean;
  togglePassword: () => void;
}

const PasswordToggle: React.FC<PasswordToggleProps> = ({
  showPassword,
  togglePassword,
}) => {
  return (
    <button
      type="button"
      onClick={togglePassword}
      className="flex items-center text-muted-foreground hover:text-foreground transition-colors duration-200 ml-1 focus-none"
      tabIndex={-1}
    >
      {showPassword ? (
        <EyeOff className="h-4 w-4" />
      ) : (
        <Eye className="h-4 w-4" />
      )}
    </button>
  );
};

export default PasswordToggle;
